import * as FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import { sendCheck, statusCheck } from './table'

const exportExcel = (tableName: any) => {
  if (!tableName) return
  const attrName = `[data-tname="${tableName}"]`
  const tableElm = document?.querySelector(attrName)
  if (!tableElm) return

  const data = Array.from(tableElm?.querySelectorAll('thead > tr > th'))
  const headNames = data
    // @ts-ignore
    .filter((item) => item.innerText !== 'Action' && item.innerText !== '' && item.innerText.length > 0)
    .map((item) => {
      // @ts-ignore
      let headerText = item.innerText
      if (headerText.includes(',')) {
        headerText = `${headerText.replace(/"/g, '""')}`
      }

      return headerText
    })

  const rows = Array.from(tableElm?.querySelectorAll('tbody > tr'))
  const bodyData = rows.map((row) => {
    const rowData = Array.from(row.querySelectorAll('td'))
    return rowData
      .filter(
        (item) => item.innerText !== 'Detail' && item.innerText !== '' && item.innerText.length > 0
      )
      .map((item) => {
        let cellText = item.innerText
        if (cellText.includes(',') || cellText.includes('\n')) {
          cellText = `${cellText.replace(/"/g, '""')}`
        }

        return cellText
      })
  })

  const excelData = [headNames, ...bodyData]
  const worksheet = XLSX.utils.aoa_to_sheet(excelData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, tableName)
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  const fileName = `${tableName}`
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  })
  FileSaver.saveAs(blob, `${fileName}.xlsx`)
}

export const exportAllExcel = (tableName: string, rows: any[], columns: any[]) => {
  const headKeys: string[] = []
  const headNames: string[] = []

  if (columns) {
    columns.forEach((item: any) => {
      headKeys.push(item.dataIndex)
      headNames.push(item.title)
    })
  }

  const body = rows.map((row: any) => {
    return columns?.map((column: { dataIndex: string, status?: boolean, send?: boolean, render?: any }) => {
      if (column?.status) {
        return statusCheck(row[column.dataIndex]).text;
      } else if (column.send) {
        return sendCheck(row[column.dataIndex]).text;
      } else if (column.render) {
        return column.render(row[column.dataIndex], row)
      } else {
        return row[column.dataIndex];
      }
    })
  })

  const excelData = [headNames, ...body];

  const workbook = XLSX.utils.book_new();
  // @ts-ignore
  const worksheet = XLSX.utils.aoa_to_sheet(excelData);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet");
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
  FileSaver.saveAs(blob, `${tableName}-ALL.xlsx`)
}

export default exportExcel;